<template>
  <div>
    <b-modal id="bv-modal-change-subscription" hide-footer>
      <template #modal-title>Change subscription</template>

    <div class="p-3 bg-white rounded border">
      <div class="row">
        <div class="col">
            <div v-if="loading" class="py-3 text-center"><i class="fas fa-spinner fa-spin"></i></div>
            <div v-else v-for="(product, index) in products" :key="index.id">
            <input type="radio" :id="product.id" class="radio mr-1" :value="product.id" v-model="subscription.product_id">
            <label :for="product.id" class="radio">{{`${product.name} - ${product.sites} ${product.sites == 1 ? 'website' : 'websites'} - ${formattedPrice(product.price)} /month`}}</label>
            </div>
        </div>
      </div>
    </div>

      <div class="row pt-3 pb-2">
        <div class="col">
          <button type="button" class="btn btn-danger submit col" @click="hideModalChangeSubscription">Cancel</button>
        </div>
        <div class="col">
          <button v-if="updating" type="button" class="btn btn-success submit col">
          <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
          <button v-else type="button" class="btn btn-danger submit col" @click="saveEmail">Change</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['subscription'],

  data() {
    return {
      updating: false,
      loading: false,
      products: [],
    };
  },

  created() {
    this.getProducts();
  },

  methods: {

    getProducts() {
      this.loading = true;
      axios
        .get('/subscriptions/get-products')
        .then(response => {
          this.products = response.data;
          this.loading = false;
        });
    },

    hideModalChangeSubscription() {
      this.$bvModal.hide('bv-modal-change-subscription');
    },

            saveEmail() {

              this.updating = true;

              axios.post('/subscriptions/update', {
                subscription: this.subscription})
            .then((response) => {

              if (response.data.success) {
                this.$emit('subscription-updated');
                this.hideModalChangeSubscription();
              } else {
                this.sweetfire(response.data.message);
              }

              this.updating = false;

            });

      },

      sweetfire(text) {

        Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Ok',
        customClass: {
                title: "popup-title",
              },
        })

    },
  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
.btn { border-radius: 5px !important; }
input.form-control, input.form-control:focus {
  border-radius: 5px !important;
  border: none !important;
}
.border{border: 1px solid #000 !important;}
</style>